import React, { Fragment } from 'react'
import {
  Button,
  Drawer,
  Input,
  Row,
  Col,
  Table,
  Upload,
  Select,
  Alert
} from 'antd'
import { Programme, Course } from '../../interfaces'
import {studentYear, semesters, academicYears} from '../../helpers/constants'

interface Props {
  values: any
  onSubmit: (values: any) => void
  Form: any
  form: any
  onShowDrawer: (value: boolean) => void
  showDrawer: boolean
  handleExcelSheet: (info: any) => void
  excelData: any[]
  beforeUpload: (file: File) => boolean
  uploadButton: React.ReactNode
  isSubmit: boolean
  error: any
  handleSheetNumber: (e: any) => void
}

const { Option } = Select

const columns: any[] = [
  {
    title: 'Index Number',
    dataIndex: 'index_no',
    align: 'left',
    key: 'index_no'
  },
  {
    title: 'Total Credit Units',
    dataIndex: 'tcu',
    align: 'left',
    key: 'tcu'
  },
  {
    title: 'Total Grade Points',
    dataIndex: 'tgp',
    align: 'left',
    key: 'tgp'
  },
  {
    title: 'Grade Point Average',
    dataIndex: 'gpa',
    align: 'left',
    key: 'gpa'
  },
  {
    title: 'Cumulative Grade Point Average',
    dataIndex: 'cgpa',
    align: 'left',
    key: 'cgpa'
  }
]

const GPAsDrawer: React.FC<Props> = (props) => {
  const {
    values,
    Form,
    form,
    onShowDrawer,
    onSubmit,
    showDrawer,
    beforeUpload,
    excelData,
    handleExcelSheet,
    uploadButton,
    isSubmit,
    error,
    handleSheetNumber,
  } = props

  let data: any[] = []

  excelData.length &&
    excelData.map((gpaFileData, i) => {
      data.push({
        key: i,
        index_no: gpaFileData['Index Number'],
        tcu: parseFloat(gpaFileData['TCU']).toFixed(2),
        tgp: parseFloat(gpaFileData['TGP']).toFixed(2),
        gpa: parseFloat(gpaFileData['GPA']).toFixed(2),
        cgpa: parseFloat(gpaFileData['CGPA']).toFixed(2)
      })
      return data
    })

  const renderAlertMessage = () => {
    return ''
  }

  return (
    <Fragment>
      <Drawer
        width={1000}
        placement="right"
        closable
        onClose={() => onShowDrawer(false)}
        visible={showDrawer}
        title="Upload Grade Point Averages"
      >
        <Row>
          <Row style={{ marginBottom: 10 }}>
            <Col span={12} md={12} sm={24} xs={24} style={{ marginBottom: 10 }}>
              <Button
                type="primary"
                href="https://admission.ebitsapps.com/uploads/gpa_template.xlsx"
              >
                Download Template
              </Button>
            </Col>
            {error ? (
              <Col span={24} md={24} sm={24} xs={24}>
                <Alert
                  message={<div dangerouslySetInnerHTML={{__html: error.title ? error.title : '<strong>Error Occurred</strong>'}}></div>}
                  description={<div dangerouslySetInnerHTML={{__html: error.message}}></div>}
                  type="error"
                  showIcon
                />
              </Col>
            ) : null}
          </Row>
          <Col span={24}>
            <Form
              layout="vertical"
              name="basic"
              initialValues={values}
              onFinish={onSubmit}
              id="gpasform"
              form={form}
            >
              <Form.Item name="school_id" hidden={true}>
                <Input type="text" />
              </Form.Item>
              <Row gutter={10}>
                <Col span={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="sheet"
                    label="Sheet number"
                    rules={[
                      { required: true, message: 'Sheet number is required!' }
                    ]}
                  >
                    <Input
                      placeholder="Sheet number.."
                      type="number"
                      onChange={handleSheetNumber}
                    />
                  </Form.Item>
                </Col>
                <Col span={12} md={12} sm={24} xs={24}>
                  <Form.Item
                      name="year"
                      label="Year / Level"
                      rules={[{ required: true, message: 'Year is required!' }]}
                  >
                    <Select placeholder="Select the year..">
                      {studentYear.map((yr) => (
                          <Option value={yr.value} key={yr.value}>
                            {yr.label}
                          </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={10}>
                <Col span={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name="semester"
                    label="Semester"
                    rules={[
                      { required: true, message: 'Semester is required!' }
                    ]}
                  >
                    <Select placeholder="Select the semester..">
                      {semesters.map((s) => (
                        <Option value={s.value} key={s.value}>
                          {s.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12} md={12} sm={24} xs={24}>
                  <Form.Item
                      name="academic_year"
                      label="Academic Year"
                      rules={[
                        { required: true, message: 'Academic year is required!' }
                      ]}
                  >
                    <Select placeholder="Select the academic year..">
                      {academicYears.map((aca) => (
                          <Option value={aca.value} key={aca.value}>
                            {aca.label}
                          </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={10}>
                <Col span={24} md={24} sm={24} xs={24}>
                  <Form.Item label="Excel Sheet">
                    <Upload
                      name="excel"
                      listType="picture-card"
                      className="seo-uploader"
                      showUploadList={false}
                      beforeUpload={beforeUpload}
                      onChange={handleExcelSheet}
                      accept=".xlsx"
                    >
                      {uploadButton}
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              {excelData.length ? (
                <Row style={{ marginBottom: 10 }}>
                  <Col span={24}>
                    <div>
                      <Table
                        dataSource={data}
                        columns={columns}
                        bordered
                        pagination={{
                          hideOnSinglePage: true,
                          total: excelData.length,
                          showTotal: (total, range) => {
                            return `Showing ${range[0]} - ${range[1]} of ${total} results`
                          }
                        }}
                        className="students-table"
                        scroll={{ x: true }}
                      />
                    </div>
                  </Col>
                </Row>
              ) : null}
              <Row gutter={20}>
                <Col span={24}>
                  <Button
                    form="gpasform"
                    key="submit"
                    htmlType="submit"
                    type="primary"
                    loading={isSubmit}
                  >
                    {isSubmit ? 'Saving...' : 'Save'}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Drawer>
    </Fragment>
  )
}

export default GPAsDrawer
